/*
import { LEAVE_SELECTOR } from '@angular/animations/browser/src/util';
import { open } from '@angular/tsc-wrapped/test/typescript.mocks';
import { TogetherAuctionDIPIncomeDetails_PaymentPeriodType } from '../models/api.models';
import { TogetherAuctionDIPAdditionalDetailsComponent }
                        from '../components/dip.additional_details.component';
import { TogetherHeaderLink, TogetherHeaderLinks } from './../models/app.models';
*/
import { environment } from './../../environments/environment';
import { TogetherAuctionEndPoint } from './endpointparams';

import { TogetherAuctionDIPEntityType, TogetherAuctionDIPEntityOperation } from './../models/enums';
import * as _ from 'lodash-es';

export const AppAPIURL = environment.AppApiUrl;

export const AppAPIURLs = {
  save_loan_details: '/case/:case_id/loan_details/save',
  get_loan_details: '/case/:case_id/loan_details/get',
  get_applicants: '/case/:case_id/applicants/get',
  save_applicant_details: '/case/:case_id/applicants/save',
  delete_applicants: '/case/:case_id/applicants/:applicant_id/delete',
  delete_applicant_address: '/case/:case_id/applicants/:address_id/deleteApplicantAddress',
  get_employment_details: '/case/:case_id/employment_details/get',
  save_employment_details: '/case/:case_id/employment_details/:applicant_id/save',
  delete_employment_details: '/case/:case_id/applicants/:applicant_id/employment_details/:emp_details_id/delete',
  save_security: '/case/:case_id/security/:security_id/save',
  get_security: '/case/:case_id/security/get',
  delete_security: '/case/:case_id/security/:security_id/delete',
  get_solicitor: '/case/:case_id/solicitor/get',
  save_solicitor: '/case/:case_id/solicitor/:solicitor_id/save',
  submit_dip: '/case/:case_id/submit_dip',
  submit_quote: '/case/:case_id/submit_quote',
  get_detail: '/case/:case_id/get_detail',
  address_search: '/address/search/:postcode',
  address_get: '/address/get/:id',
  // jwt_get: '/jwt/get/:string',
  // jwt_validate: '/jwt/try/:string',
  jwt_get_post: '/jwt/get',
  jwt_validate_post: '/jwt/try',
  save_address_match: '/address/match/:address_id/:code',
  copy_loan_details: '/case/:case_id/copy',
  exitingcharge_delete: 'case/:case_id/security/:security_id/exitingcharge/:existingCharge_id/delete',
  requote_dip: '/case/:caseid/requote_dip/:planname/save',
};

export class TogetherAuctionDIPEntities {

  private API_ENDPOINT_PARAMS: Map<String, Object> =
    new TogetherAuctionEndPoint().API_ENDPOINT_PARAMS;

  // tslint:disable-next-line:prefer-array-literal
  private nonCaseEntities: Array<TogetherAuctionDIPEntityType> = [
    TogetherAuctionDIPEntityType.Address,
    TogetherAuctionDIPEntityType.JWT,
    TogetherAuctionDIPEntityType.CompanyLookup,
  ];

  isNonCaseEntity(entityType: TogetherAuctionDIPEntityType) {
    return this.nonCaseEntities.indexOf(entityType) !== -1;
  }

  getJWTPostUrl(type = 'get') {
    const url = (type === 'get')
      ? AppAPIURL + AppAPIURLs['jwt_get_post']
      : AppAPIURL + AppAPIURLs['jwt_validate_post'];
    return url;
  }

  generateURLToken(parameters: Object = {}) {
    let url = parameters['is_case_entity'] ? '/case' : '/:prefix';
    url += !_.isNil(parameters['has_case_entity_id']) ? '/:case_entity_id' : '';
    url += !_.isNil(parameters['has_entity']) ? '/:entity' : '';
    url += !_.isNil(parameters['has_entity_id']) ? '/:entity_id' : '';
    url += !_.isNil(parameters['has_sub_entity']) ? '/:sub_entity' : '';
    url += !_.isNil(parameters['has_sub_entity_id']) ? '/:sub_entity_id' : '';
    url += !_.isNil(parameters['has_operation']) ? '/:operation' : '';
    return url;
  }

  getURLConfig(entityType: TogetherAuctionDIPEntityType,
    operationType: TogetherAuctionDIPEntityOperation) {
    const name = this.getEntityURLName(entityType, operationType);
    return this.API_ENDPOINT_PARAMS.get(name);
  }

  getURLPrefix(entityType: TogetherAuctionDIPEntityType,
    operationType: TogetherAuctionDIPEntityOperation) {
    return this.getURLConfig(entityType, operationType)['prefix'];
  }

  getEntityURLName(entityType: TogetherAuctionDIPEntityType,
    operationType: TogetherAuctionDIPEntityOperation) {
    const type = TogetherAuctionDIPEntityNames[entityType];
    const op = TogetherAuctionDIPEntityOperationNames[operationType];
    return type + '_' + op;
  }

  /**
   * Generates out the full URL tokenized string for the given API endpoint.
   *
   * @param {TogetherAuctionDIPEntityType} entityType
   * @param {TogetherAuctionDIPEntityOperation} operationType
   * @returns
   * @memberof TogetherAuctionDIPEntities
   */
  generateURL(entityType: TogetherAuctionDIPEntityType,
    operationType: TogetherAuctionDIPEntityOperation) {

    // Get the name.
    const name = this.getEntityURLName(entityType, operationType);

    // Now get the parameters.
    const params = this.API_ENDPOINT_PARAMS.get(name);

    // Now generate out the URL token
    return this.generateURLToken(params);
  }

  /**
   * Gets the name of the operation to be appended to the URL.
   *
   * @param {TogetherAuctionDIPEntityType} entityType
   * @param {TogetherAuctionDIPEntityOperation} operationType
   * @returns
   * @memberof TogetherAuctionDIPEntities
   */
  getEntityURLOperation(entityType: TogetherAuctionDIPEntityType,
    operationType: TogetherAuctionDIPEntityOperation) {
    return TogetherAuctionDIPEntityOperationNames[operationType];
  }

  /**
   * Fills the URL with the prefixes based upon the
   *
   * @param {TogetherAuctionDIPEntityType} entityType
   * @param {TogetherAuctionDIPEntityOperation} operationType
   * @param {string} case_entity_id
   * @param {string} [entity_id=null]
   * @param {string} [sub_entity_id=null]
   * @returns
   * @memberof TogetherAuctionDIPEntities
   */
  getURL(entityType: TogetherAuctionDIPEntityType,
    operationType: TogetherAuctionDIPEntityOperation,
    case_entity_id: string,
    entity_id: string = null,
    sub_entity_id: string = null) {

    // Generate out the token.
    const urlToken = this.generateURL(entityType, operationType);

    // Get the parameters.
    const urlConf = this.getURLConfig(entityType, operationType);

    // Does the prefix exist?
    const hasPrefix = urlToken.indexOf(':prefix') !== -1;

    // If it has a prefix.
    if (hasPrefix) {
      urlToken.replace(':prefix', this.getURLPrefix(entityType, operationType));
    }

    // Now replace this.
    return AppAPIURL + urlToken
      .replace(':case_entity_id', case_entity_id)
      .replace(':entity', urlConf['entity'])
      .replace(':entity_id', entity_id)
      .replace(':sub_entity', urlConf['sub_entity'])
      .replace(':sub_entity_id', sub_entity_id)
      .replace(':operation', this.getEntityURLOperation(entityType, operationType));
  }

  generateAPIURL(operation, is_address = false, is_match = false, has_sub_entity = false) {
    if (!is_address) {
      let url = '/case/:case_id/:entity/';

      if (operation === TogetherAuctionDIPEntityOperation.Save
        || operation === TogetherAuctionDIPEntityOperation.Delete) {

        if (has_sub_entity) {
          url += ':entity_id/:sub_entity_type/:operation';
        } else {
          url += ':entity_id' + '/:operation';
        }
      } else {
        url += ':operation';
      }

      return url;
    }
    let addr = '/address/';
    addr += is_match ? 'match/' : '';
    addr += ':operation/:action';
    return addr;

  }

  fillAPIURL(op_type, operation, case_id,
    entity_id: string = '00000000-0000-0000-0000-000000000000', sub_entity_id: string = null) {

    let url = this.getAPIURL(op_type, operation).replace(':case_id', case_id);
    if (url.indexOf(':entity_id') !== -1) {
      url = url.replace(':entity_id', entity_id);
    }
    if (url.indexOf(':sub_entity_id') !== -1) {
      url = url.replace(':sub_entity_id', sub_entity_id);
    }
    return url;
  }

  fillAPIURLAddress(address_id, code) {
    let url = this.generateAPIURL(null, true, true);
    url = url.replace(':operation', address_id).replace(':action', code);
    return AppAPIURL + url;
  }

  getAPIURL(op_type, operation, case_id = null) {
    const op = TogetherAuctionDIPEntityOperationNames[operation];
    const type = TogetherAuctionDIPEntityNames[op_type];
    let url = AppAPIURL;

    if (op_type === TogetherAuctionDIPEntityType.Address) {
      url += this.generateAPIURL(null, true);
      return url.replace(':operation', type).replace(':action', op);
    }
    if (op_type === TogetherAuctionDIPEntityType.EmploymentDetails &&
      ['delete', 'save'].indexOf(op) !== -1) {
      url += this.generateAPIURL(operation, false, false, true);
    }

    url += this.generateAPIURL(operation);
    return url.replace(':entity', type).replace(':operation', op);
  }
}

export const TogetherAuctionDIPEntityNames: Array<string> = [
  'loan_details', 'applicants', 'employment_details',
  'security', 'solicitor', '',
  'address', 'submit_dip', 'submit_quote',
  'detail', 'stage', 'certificate', 'recap', 'business_applicants',
  'jwt', 'company', 'applicant_address',
  'address', 'exitingcharge',
];

export const TogetherAuctionDIPEntityOperationNames: Array<string> = [
  'get',
  'save',
  'delete',
  'find',
  'try',
  'none',
  'match',
];


/**
 * Gets the API URL for a given operation.
 *
 * @export
 * @param {string} operation
 * @returns
 */
export function getAPIURL(operation: string) {
  return AppAPIURL + AppAPIURLs[operation];
}
